import { UserAccountRoleEnum, SingleUser } from '../api/types';

interface GetRollTextProps {
  capitalize?: boolean;
  pluralize?: boolean;
}

export class User implements SingleUser {
  private static readonly userRelationRoleToTextMap = {
    [UserAccountRoleEnum.administration]: 'administrateur',
    [UserAccountRoleEnum.caregiver]: 'behandelaar',
    [UserAccountRoleEnum.adminCaregiver]: 'behandelaar',
    [UserAccountRoleEnum.client]: 'cliënt',
    [UserAccountRoleEnum.thirdParty]: 'betrokkene',
  };

  private static readonly userRelationRoleToTextPluralsMap = {
    [UserAccountRoleEnum.administration]: 'administrateurs',
    [UserAccountRoleEnum.caregiver]: 'behandelaren',
    [UserAccountRoleEnum.adminCaregiver]: 'behandelaren',
    [UserAccountRoleEnum.client]: 'cliënten',
    [UserAccountRoleEnum.thirdParty]: 'betrokkenen',
  };

  id: number;
  accountId?: number;
  name: string;
  accountRole: UserAccountRoleEnum;
  initials?: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: Date;
  createdAt?: Date;
  lastActivity?: Date;


  constructor(userData: SingleUser) {
    const { id, accountId, name, accountRole, initials, firstName, lastName, dateOfBirth, createdAt, lastActivity } = userData;
    this.id = id;
    this.accountId = accountId;
    this.name = name;
    this.accountRole = accountRole;
    this.initials = initials;
    this.firstName = firstName;
    this.lastName = lastName;
    this.dateOfBirth = dateOfBirth ? new Date(dateOfBirth) : undefined;
    this.createdAt = createdAt ? new Date(createdAt) : undefined;
    this.lastActivity = lastActivity ? new Date(lastActivity) : undefined;
  }

  static getRoleText(role: UserAccountRoleEnum, { capitalize, pluralize }: GetRollTextProps = {}): string {
    const map = pluralize ? User.userRelationRoleToTextPluralsMap : User.userRelationRoleToTextMap;
    const text = map[role] || '[onbekend rol type]';
    if (capitalize) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    } else {
      return text;
    }
  }

  match(user: SingleUser): boolean {
    return this.id === user.id;
  }

  getRoleText(options?: GetRollTextProps): string {
    return User.getRoleText(this.accountRole, options);
  }

  toSingleUser(): SingleUser {
    return {
      id: this.id,
      name: this.name,
      accountRole: this.accountRole,
      createdAt: this.createdAt?.toString(),
    };
  }

  /**
   * @deprecated
   */
  get hasMultipleRoles(): boolean {
    return false;
  }
}
